export default function PolicyContent() {
  return (
    <div className="policy-context">
      <section>
        <h3>총칙</h3>
        <p>
          주식회사 이든파이낸셜(이하 ‘회사’라 함)은 「정보통신망 이용촉진 및
          정보보호 등에 관한 법률」, 「개인정보보호법」 등의 관련 법령에 따라
          이든든 서비스 이용자(이하 ‘회원’이라 함)의 개인정보 및 개인신용정보를
          보호하고 개인신용정보와 관련한 이용자의 고충을 원활하게 처리할 수
          있도록 다음과 같은 ‘개인정보 처리방침’.에 따라 개인신용정보를 처리하고
          있습니다. <br />
          회사가 {"<개인정보 처리방침>"}을 개정하는 경우에는 이를 홈페이지에
          게시합니다.
        </p>
      </section>
      <section>
        <h3>제 1조 개인정보의 처리목적</h3>
        <p>
          회사는 서비스 이용에 필요한 개인신용정보를 다음과 같은 목적을 위하여
          처리합니다. 처리하는 개인신용정보는 다음의 목적 이외의 용도로는
          이용되지 않으며, 처리 목적이 변경되는 경우에는 별도의 동의를 받는 등
          필요한 조치를 이행할 것입니다.
        </p>
        <p>
          회사는 이든든 서비스 (이하 “서비스”) 이용에 필요한 개인(신용)정보만을
          수집하고 있습니다.
        </p>
        <p>
          처음으로 이용하는 서비스의 경우 회사는 이용자에게 필수적인 정보의
          입력을 요청할 수 있으며, 회사가 이미 보유한 정보가 있다면 입력을
          생략하거나 이용자를 위하여 입력편의성을 제공할 수 있습니다.
        </p>
        <span>(필수)</span>
        <ul className="circle-list">
          <li>이용자 식별, 본인확인, 연령 확인, 불량 회원 처리</li>
          <li>서비스 제공에 관한 계약 이행, 맞춤형 서비스 제공</li>
          <li>신규 서비스의 개발, 이용 기록 분석, 서비스 개선</li>
          <li>상담, 불만 처리, 부정이용 처리, 공지사항 전달</li>
          <li>
            성별, 연령, 주거형태, 소득정보 등 통계학적 특성 분석에 기반한 개인
            맞춤형 금융 상품 정보 제공
          </li>
          <li>
            이용자가 가입한 대출상품 정보에 기반한 개인 맞춤형 대출 상품, 관련
            부대 서비스 제공
          </li>
          <li>대출 간편 서류 제출을 통해 이용자 편의 제공</li>
          <li>그 밖에 이용자의 가입 목적 달성을 위해 필요한 처리</li>
        </ul>
        <br />
        <span>(선택)</span>
        <ul className="circle-list">
          <li>
            회사 및 제휴사의 상품 및 서비스에 대한 광고, 홍보, 프로모션 제공,
            고객 만족도 조사
          </li>
          <li>회사 및 제휴사의 상품 및 서비스 이용 방법 안내</li>
        </ul>
        <br />
        <p>
          회사는 원활한 서비스 제공을 위하여 회원에게 회사가 제공하는 웹서비스
          및 모바일 어플리케이션과 이메일, SMS를 통한 광고 및 서비스 관련 정보를
          제공할 수 있으며, 원치 않는 경우 언제든지 수신거부 할 수 있습니다.
          광고ㆍ마케팅 수신 여부는 선택 사항이므로 동의를 거부하는 경우에도
          서비스의 이용에는 영향이 없습니다. 또한, 광고ㆍ마케팅 수신 여부는 앱
          또는 고객센터를 통해 언제든지 철회할 수 있습니다.
        </p>
        <p>
          개인정보는 이용자의 서비스의 이용 기간에만 활용되며, 이용목적이 달성이
          되거나 보유기간이 종료된 경우 지체 없이 파기합니다. 단, 내부 방침에
          의해 이용자에게 개인정보 보관기간에 대해 별도의 동의를 얻은 경우, 또는
          법령에서 일정 기간 정보보관 의무를 부과하는 경우에는 해당 기간 동안
          개인정보를 안전하게 보관합니다. <br />
          법령 및 회사 내부방침에 의해 보존해야만 하는 경우 아래와 같이 일정
          기간동안 이용자정보를 보존합니다.
        </p>
        <span>(법령에 따라 보존하여야 하는 경우)</span>
        <ul className="blank-list" style={{ marginBottom: "16px" }}>
          <li>「전자상거래 등에서의 소비자보호에 관한 법률」</li>
          <ul className="blank-list">
            <li>- 계약 또는 청약철회 등에 관한 기록: 5년</li>
            <li>- 대금결제 및 재화 등의 공급에 관한 기록: 5년</li>
            <li>- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년</li>
            <li>- 표시•광고에 관한 기록: 6개월</li>
          </ul>
          <li>「전자금융거래법」 – 전자금융에 관한 기록: 5년</li>
          <li>
            「통신비밀보호법」 – 로그인 기록(로그기록자료, 접속지의 추적자료):
            3개월
          </li>
        </ul>
        <span>(회사 내부 방침에 따라 보존하여야 하는 경우)</span>
        <ul className="blank-list">
          <li>대출조건 확인을 위해 제휴 금융사로부터 수집한 정보 : 1개월</li>
          <ul className="blank-list">
            <li>- 대출조회 시 : 조회일로부터 익일24시까지</li>
            <li>- 대출신청 시 : 대출신청일로부터 1개월</li>
            <li>- 대출완료 시 : 제1조에 명시된 법령에 따라 보존</li>
          </ul>
          <li>서비스 문의를 위해 이용자로부터 입력받은 정보 : 1년</li>
          <li>상담에 대한 내용 및 개인정보 : 상담완료 후 1년</li>
          <li>
            불량 이용자 제재나 관련 분쟁 처리 등 서비스 관리를 위한 개인정보 :
            1년
          </li>
        </ul>
      </section>
      <section>
        <h3>제 2조 개인정보의 수집방법 및 항목</h3>
        <p>
          회사는 고객의 서비스이용과정에서 서비스 제공 및 상담, 법령상의
          의무이행 등을 위해 필요한 범위 내에서 고객으로부터 아래와 같은
          개인정보를 수집하고 있습니다.
        </p>
        <ul>
          <li className="li-group">(서비스 이용시 수집될 수 있는 정보)</li>
          <ul className="circle-list">
            <li>
              이름, 생년월일, 주민등록번호, 외국인등록번호, 성별, 주소,
              이메일주소, 휴대전화번호, 이동통신사정보, 자산(세대원포함),
              직업정보, 소득, 신용조회결과, 서비스 이용기록 등 기타 서비스
              이용과정에서 입력한 정보, 가심사결과 및 심사결과 정보
            </li>
          </ul>
          <li className="li-group">(개인정보의 수집방법)</li>
          <ul className="circle-list">
            <li>이든든 앱 내에서 고객이 직접 입력한 정보</li>
            <li>이든든 앱 내 조회서비스를 통해 고객이 조회한 정보</li>
            <li>
              특정 서비스의 사용을 위해서 제휴사가 고객의 사전동의를 받은 후
              회사에게 제공한 정보
            </li>
            <li>상담 과정에서 생성된 정보</li>
            <li>서비스 이용과정에서 자동으로 수집되는 정보</li>
          </ul>
        </ul>
      </section>
      <section>
        <h3>제 3조 개인정보의 처리 및 보유기간</h3>
        <p>
          회사는 법령에 따른 개인정보 보유기간 또는 정보주체로부터 개인정보를
          수집 시에 동의 받은 개인정보 보유기간 내에서 개인정보를 처리합니다.
        </p>
        <p>
          회사는 고객이 개인정보 수집ㆍ이용에 대한 동의를 철회하는 경우,
          수집ㆍ이용 목적이 달성되거나 보유기간이 종료한 경우에는 해당
          개인정보를 지체없이 파기합니다. 단, 다음의 정보에 대해서는 아래에
          명시한 기간 동안 보존할 수 있습니다.
        </p>
        <ul className="number-list">
          <li>
            <span>(1)</span>
            <span>
              (금융)거래와 관련한 개인(신용)정보는 수집ㆍ이용에 관한
              동의일로부터 (금융)거래 종료일로부터 5년까지 위 이용목적을 위하여
              보유ㆍ이용됩니다.
            </span>
          </li>
          <li>
            <span>(2)</span>
            <span>
              개인(신용)정보의 조회를 목적으로 수집된 개인(신용)정보는
              수집ㆍ이용에 대한 동의일로부터 고객에 대한 신용정보 제공ㆍ조회
              동의의 효력 기간까지 보유ㆍ이용됩니다.
            </span>
          </li>
          <li>
            <span>(3)</span>
            <span>
              상품 및 서비스 홍보 및 판매 권유 등과 관련한 개인(신용)정보는
              수집ㆍ이용에 관한 동의일로부터 동의 철회일가지 보유ㆍ이용됩니다.
            </span>
          </li>
          <li>
            <span>(4)</span>
            <span>
              금융 거래 관련한 개인(신용)정보는 전자금융거래법 시행령 제12조에서
              정하는 기간까지 보유ㆍ이용됩니다.
            </span>
          </li>
          <li>
            <span>(5)</span>
            <span>
              광고/마케팅 수신동의 여부는 동의 철회시까지 보유ㆍ이용됩니다.
              (광고/마케팅 수신 동의 후 매 2년마다 수신동의 여부를 확인하는
              안내를 드립니다.)
            </span>
          </li>
        </ul>
        <span>
          다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지
          보유ㆍ이용됩니다.
        </span>
        <ul className="circle-list">
          <li>
            관계 법령 위반에 따른 수사/조사 등이 진행 중인 경우에는 해당
            수사/조사 종료 시까지
          </li>
          <li>
            환불, 환급 등 채권/채무관계 정산 시까지 이름, 휴대전화번호, 계좌번호
            등의 필수적 정보를 이용
          </li>
        </ul>
      </section>
      <section>
        <h3>제 4조 개인정보의 제 3자 제공</h3>
        <p>
          회사는 서비스 이용에 필요한 회원의 개인정보를 다음의 목적을 위해
          제휴사에 제공합니다. 처리하는 개인정보는 다음의 목적 이외의 용도로는
          이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등
          필요한 조치를 이행할 것입니다. 회사는 서비스 이용에 필요한 최소한의
          개인정보만을 제3자에게 제공하고 있습니다.
        </p>
        <p>
          서비스를 처음으로 이용하는 경우 회사는 이용자에게 필수적인 정보의
          입력을 요청할 수 있으며, 회사가 이미 보유한 정보가 있다면 입력을
          생략하거나 이용자를 위한 입력 편의성을 제공할 수 있습니다. 그리고,
          회사는 대부분의 서비스에 대하여 ‘취소’ 또는 ‘철회’ 기능을 제공함으로써
          이미 동의한 개인정보의 제3자 제공에 대하여 언제든지 취소하고 삭제할 수
          있는 방법을 제공하고 있습니다.
        </p>
        <p>
          서비스 이용자는 동의를 거부할 권리가 있으며, 동의하지 않을 경우 해당
          서비스의 이용은 불가능하지만 다른 서비스의 이용에는 문제가 없습니다.
        </p>
        <span>(개인정보처리) ㈜다날</span>
        <ul className="circle-list" style={{ marginBottom: "12px" }}>
          <li>
            제공목적 : 본인 식별을 통한 신용등급, 신용점수 등의 고객신용정보
            확인
          </li>
          <li>
            제공항목 : 이름, 생년월일, 성별, 이동전화번호, 내외국인구분,
            중복가입확인정보(DI), 암호화된 동일인 식별정보(CI), 아이핀
            번호(아이핀 이용 시)
          </li>
        </ul>
        <span>
          (금융기관) ㈜다올저축은행, ㈜키움저축은행, ㈜애큐온캐피탈,
          ㈜동원제일저축은행
        </span>
        <ul className="circle-list">
          <li>
            제공목적 : 금융상품안내 및 이용, 예금주 계좌 유효성 체크 대출신청
            정보의 접수 확인 및 제출
          </li>
          <li>
            제공항목 : 연계정보(CI), 성명, 통신사, 휴대전화번호, 생년월일,
            대출심사 신청내역, 약정 신청 내역, 실행 신청 내역, 상환요청 내,
            은행명, 계좌번호
          </li>
        </ul>
        <span>
          [참고] 보유 기간이 기재되어 있지 않은 경우에는 1) 제공 목적이 달성되는
          시점 2) 관련법령에 따른 보존 기간까지 제공된 정보가 이용됨을 알려
          드립니다.
        </span>
      </section>
      <section>
        <h3>제 5조 개인정보의 처리 위탁</h3>
        <p style={{ marginBottom: 0 }}>
          회사는 원활한 서비스 제공을 위해 반드시 필요한 경우 업무 중 일부를
          외부 수탁 업체로 하여금 수행하도록 하고 개인정보를 위탁하고 있습니다.
          <br />
          회사가 현재 위탁한 업무 내용별 수탁업체는 다음과 같습니다.
        </p>
        <ul className="circle-list">
          <li>㈜쿠콘 : 금융사와 회사간 API통신 중계역할</li>
        </ul>
        <span>
          수탁업체는 회원 탈퇴 또는 위탁계약 종료 시까지 개인정보를 보유 및
          이용할 수 있습니다.
        </span>
      </section>
      <section>
        <h3>제 6조 개인정보의 파기 절차 및 파기 방법</h3>
        <p>
          회사는 이용자의 정보를 개인정보의 수집 및 이용목적 달성 시 지체없이
          파기합니다. <br />
          다만, 법령 또는 내부방침에 의해 보존해야만 하는 경우 별도의 DB로
          옮겨져(종이의 경우 별도의 서류함) 일정 기간 보관한 후 파기됩니다.
        </p>
        <p>
          종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기하며,
          전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적
          방법을 사용하여 삭제합니다.
        </p>
      </section>
      <section>
        <h3>제 7조 회원 및 법정대리인의 권리와 그 행사방법</h3>
        <ul className="number-list">
          <li>
            <span>(1)</span>
            <span>
              회원 및 법정대리인은 자신 또는 자신이 대리한 자의 개인정보를
              조회하거나 수정할 수 있으며 개인정보 삭제 및 이용계약 해지를
              요청할 수도 있습니다.
            </span>
          </li>
          <li>
            <span>(2)</span>
            <span>
              회원의 개인정보 조회, 수정, 이용계약 해지를 위해서는 회사가 마련한
              절차를 거치며, 개인정보관리책임자에게 서면, 전화 또는 이메일로
              연락하여 개인정보의 조회, 수정 및 이용계약 해지 요청이 가능합니다.
            </span>
          </li>
          <li>
            <span>(3)</span>
            <span>
              회사는 회원 또는 법정대리인이 파기 요청한 개인정보는 "개인정보의
              보유기간 및 파기"에 명시된 바에 따라 처리하고 그 외의 용도로 열람
              또는 이용할 수 없도록 처리합니다.
            </span>
          </li>
          <li>
            <span>(4)</span>
            <span>
              이에 따른 권리 행사는 회사에 대해 전화 등을 통하여 하실 수
              있습니다. 고객센터(1544-9664)로 연락하여 주십시오.
            </span>
          </li>
        </ul>
      </section>
      <section>
        <h3>제 8조 개인정보의 안전성 확보 대책</h3>
        <p>
          회사는 고객의 개인(신용)정보를 보호하기 위해 아래와 같이 대책을
          마련하여 이를 적용하고 있습니다.
        </p>
        <ul className="number-list">
          <li>
            <span>(1)</span>
            <span>관리적 대책</span>
          </li>
          <ul className="number-list">
            <li>
              <span>- </span>
              <span>
                회사는 고객의 개인(신용)정보에 대한 접근과 관리에 필요한 절차
                등을 마련하여 소속 직원으로 하여금 이를 숙지하여 지키도록 하고
                있으며, 개인정보보호 의무 등에 관한 정기적인 교육을 시행하고
                있습니다.
              </span>
            </li>
            <li>
              <span>- </span>
              <span>
                회사는 고객의 개인(신용)정보에 대한 접근권한을 최소한의 인원으로
                제한하고 있습니다.
              </span>
            </li>
            <li>
              <span>- </span>
              <span>
                전산실과 자료 보관실 등을 특별보호구역으로 설정하여 출입을
                통제하고 있습니다.
              </span>
            </li>
          </ul>
          <li>
            <span>(2)</span>
            <span>기술적 대책</span>
          </li>
          <ul className="number-list">
            <li>
              <span>- </span>
              <span>
                고객의 개인(신용)정보는 암호화되어 안전하게 보호/저장되고
                있으며, 중요한 데이터는 별도의 보안 프로그램 설치,
                접근통제시스템 설치, 접근 권한 관리 등의 기능을 통해 보호되고
                있습니다.
              </span>
            </li>
          </ul>
        </ul>
      </section>
      <section>
        <h3>제 9조 개인정보의 안전성 확보조치</h3>
        <p style={{ marginBottom: "12px" }}>
          회사는 회원의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출,
          변조 또는 훼손되지 않도록 다음과 같은 기술적/관리적 대책을 강구하고
          있으며, 회사의 귀책사유 없이 회원 아이디, 비밀번호 등 개인정보가
          유출되어 발생한 문제에 대해 회사는 일체의 책임을 지지 않습니다.
        </p>
        <ul className="number-list">
          <li>
            <span>(1)</span>
            <span>비밀번호 암호화</span>
          </li>
          <li style={{ marginLeft: "28px" }}>
            회원 아이디의 비밀번호는 암호화되어 저장 및 관리되고 있어 본인만이
            알고 있으며, 개인정보의 확인 및 변경은 회원에 의해서만 가능합니다.
          </li>
          <li>
            <span>(2)</span>
            <span>해킹 등에 대비한 대책</span>
          </li>
          <li style={{ marginLeft: "28px" }}>
            회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가
            유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다.
            개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신
            백신프로그램을 이용하여 회원들의 개인정보나 자료가 누출되거나
            손상되지 않도록 방지하고 있으며, 암호화통신 등을 통하여
            네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다.
            그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고
            있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 기술적
            장치를 갖추는데 노력하고 있습니다.
          </li>
        </ul>
      </section>
      <section>
        <h3>제 10조 개인정보 보호책임자</h3>
        <p>
          회사는 사용자의 개인정보를 보호하고 개인정보와 관련한 고충 처리를
          위하여 다음과 같이 개인정보보호책임자를 지정하고 있습니다.
        </p>
        <ul className="blank-list" style={{ margin: "16px 0" }}>
          <li>
            <strong>
              개인정보 보호책임자 (개인정보의 열람청구를 접수/처리하는 부서)
            </strong>
          </li>
          <ul className="circle-list">
            <li>이 름 : 박지훈</li>
            <li>직 책 : 부장</li>
            <li>전 화 : 1544-9664</li>
            <li>메 일 : privacy@edencorp.kr</li>
          </ul>
        </ul>
      </section>
      <section>
        <h3>제 11조 정보주체의 권익침해에 대한 구제방법</h3>
        <ul>
          <li className="li-group">
            <span>
              기타 개인정보 침해에 대한 신고나 상담이 필요한 경우에 아래 기관에
              문의 가능합니다.
            </span>
          </li>
          <div className="link-paragraph">
            <p style={{ margin: 0 }}>- 개인정보 분쟁조정위원회</p>
            <div className="link-text">
              <span>
                (<a href="http://www.kopico.go.kr">http://www.kopico.go.kr</a>
              </span>
              <span>/ (국번없이) 1833-6972)</span>
            </div>
            <p style={{ margin: 0 }}>- 개인정보 침해신고센터</p>
            <div className="link-text">
              <span>
                (
                <a href="http://privacy.kisa.or.kr">
                  http://privacy.kisa.or.kr
                </a>
              </span>
              <span>/ (국번없이) 118)</span>
            </div>
            <p style={{ margin: 0 }}>- 대검찰청 사이버범죄수사단</p>
            <div className="link-text">
              <span>
                (<a href="http://www.spo.go.kr">http://www.spo.go.kr</a>
              </span>
              <span>/ (국번없이) 1301)</span>
            </div>
            <p style={{ margin: 0 }}>- 경찰청 사이버안전지킴이</p>
            <div className="link-text">
              <span>
                (
                <a href="http://www.police.go.kr/www/security/cyber.jsp">
                  http://www.police.go.kr/www/security/cyber.jsp
                </a>
              </span>
              <span>/ (국번없이) 182)</span>
            </div>
          </div>
        </ul>
      </section>
      <section>
        <h3>제 12조 개인정보처리방침의 변경 등에 관한 사항</h3>
        <p>
          회사는 ‘개인정보처리방침’을 변경하는 경우에는 변경 및 시행시기, 변경된
          내용을 지속적으로 공개하고 변경 전•후를 모두 공개하겠습니다. 회사는
          관계 법령 또는 회사 내부 정책에 의하여 ‘개인정보처리방침’을 변경하는
          경우에는 개인정보처리방침을 변경 규정 시행일 최소 7일 전까지 웹 사이트
          공지사항을 통해 변경 및 시행 시기, 변경된 내용을 지속적으로 공개하고,
          변경 전•후를 모두 공개하겠습니다. 만약 고객 권리에 관한 중대한
          변경사항이 발생할 경우 변경 규정 시행일 최소 30일 전에 고지하겠습니다.
        </p>
        <p>이 개인정보 처리방침은 2022년 06월 07일부터 시행됩니다.</p>
      </section>
    </div>
  );
}
